import React from 'react';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';

const Orders: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Orders</h1>
      <p className="section-description">
        Manage event orders, track payment status, and handle order processing through the dashboard.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <ShoppingCartIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Order Management</h3>
              <p className="feature-description">
                Handle orders with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit orders</li>
                <li>Update order status (Pending, Paid, Cancelled)</li>
                <li>Delete individual orders</li>
                <li>Bulk delete multiple orders</li>
                <li>Track payment attempts</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ShoppingCartIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Order Details</h3>
              <p className="feature-description">
                Comprehensive order information management:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>User selection (searchable)</li>
                <li>Event selection (searchable)</li>
                <li>Quantity management</li>
                <li>Total amount tracking</li>
                <li>Order status management</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ShoppingCartIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Order List</h3>
              <p className="feature-description">
                View and manage orders in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>User name (searchable)</li>
                <li>Event title (searchable)</li>
                <li>Quantity</li>
                <li>Total amount (formatted currency)</li>
                <li>Status (color-coded badges)</li>
                <li>Payment attempts count</li>
                <li>Payment ID</li>
                <li>Creation date</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ShoppingCartIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Payment Tracking</h3>
              <p className="feature-description">
                Monitor and manage payment information:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>View transaction details</li>
                <li>Track payment attempts</li>
                <li>Monitor payment status</li>
                <li>Access payment logs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Regularly update order status to reflect current state</li>
            <li>Monitor payment attempts to identify potential issues</li>
            <li>Keep accurate records of all transactions</li>
            <li>Verify payment details before marking orders as paid</li>
            <li>Use the payment logs to track transaction history</li>
            <li>Maintain clear communication with users about order status</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Orders; 